module.exports = __webpack_public_path__ + "static/media/img7.c423633d.jpg";